










































































































import Vue from 'vue';
import { authService, googleAuthService } from '@/services';
import { RouteName } from '@/router/RouteName';
import { LinkedAccountType } from '@/models';
import { Utilities } from '@/utilities';

export default Vue.extend({
  name: 'Register',

  data: () => ({
    socialLoginType: null as LinkedAccountType | null,
    registerUsingGoogleAccountForm: {
      username: null as string | null,
      usernameRules: [(username: string) => !!username || 'Username is required'],
      idToken: null as string | null,
      formValid: false
    },
    registerForm: {
      username: null as string | null,
      usernameRules: [(username: string) => !!username || 'Username is required'],
      password: null as string | null,
      passwordRules: [
        (password: string) => !!password || 'Password is required',
        (password: string) =>
          (password && password.length >= 6 && password.length <= 256) ||
          'Password must be between 6 and 256 characters long.'
      ],
      email: null as string | null,
      emailRules: [
        (email: string) => !!email || 'Email is required',
        (email: string) => Utilities.validateEmail(email) || 'Please enter a valid email'
      ],
      formValid: false
    },
    errorMessage: null as string | null,
    loading: false
  }),

  methods: {
    async register(): Promise<void> {
      const { username, password, formValid, email } = this.registerForm;

      if (!formValid || !password || !username || !email) {
        this.errorMessage = 'Invalid form.';
        return;
      }

      try {
        this.loading = true;
        await authService.registerUser({
          username,
          password,
          email
        });
        this.errorMessage = null;
        this.$router.push({ name: RouteName.WatchLists });
      } catch (error) {
        this.errorMessage = 'Something went wrong.';
      } finally {
        this.loading = false;
      }
    },

    async registerUsingGoogleAccount(): Promise<void> {
      const { username, idToken, formValid } = this.registerUsingGoogleAccountForm;

      if (!formValid || !idToken || !username) {
        this.errorMessage = 'Invalid form.';
        return;
      }

      try {
        this.loading = true;
        await authService.registerUserUsingGoogleAccount(username, idToken);
        this.errorMessage = null;
        this.$router.push({ name: RouteName.WatchLists });
      } catch (error) {
        this.errorMessage = 'Something went wrong.';
      } finally {
        this.loading = false;
      }
    },

    resetRegisterForm(): void {
      this.errorMessage = null;
      (this.$refs.registerForm as any).reset();
    },

    resetRegisterUsingGoogleAccountForm(): void {
      this.errorMessage = null;
      (this.$refs.registerUsingGoogleAccountForm as any).reset();
    }
  },

  computed: {
    confirmPasswordRules(): ((confirmPw: string) => boolean | string)[] {
      return [(confirmPw: string) => confirmPw === this.registerForm.password || 'Passwords must match.'];
    }
  },

  mounted(): void {
    const { socialLogin } = this.$route.query;

    if (
      socialLogin &&
      socialLogin === LinkedAccountType.Google &&
      googleAuthService.isSignedIn &&
      googleAuthService.currentUser
    ) {
      this.socialLoginType = LinkedAccountType.Google;
      const currentUser = googleAuthService.currentUser;

      this.registerUsingGoogleAccountForm.idToken = currentUser.getAuthResponse().id_token;
      this.registerUsingGoogleAccountForm.username = currentUser.getBasicProfile().getEmail()?.split('@')[0] || null;
    }
  }
});
